// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: block;
}

.queue-overlay {
  position: absolute;
  inset: 0;
  pointer-events: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(1px);
}

body.dark .queue-overlay {
  background: rgba(17, 24, 39, 0.35);
}

.queue-shimmer {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 60%;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.75) 50%, transparent 100%);
  animation: queue-pending-shimmer 1.25s linear infinite;
}

body.dark .queue-shimmer {
  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.16) 50%, transparent 100%);
}

.queue-center {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
}

.queue-icon-wrap {
  width: 2.2rem;
  height: 2.2rem;
  border-radius: 9999px;
  border: 1px solid rgba(148, 163, 184, 0.6);
  background: rgba(255, 255, 255, 0.9);
  color: #334155;
  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.18);
  display: flex;
  align-items: center;
  justify-content: center;
}

body.dark .queue-icon-wrap {
  border-color: rgba(148, 163, 184, 0.45);
  background: rgba(15, 23, 42, 0.82);
  color: #e2e8f0;
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);
}

@keyframes queue-pending-shimmer {
  from {
    transform: translateX(-120%);
  }
  to {
    transform: translateX(280%);
  }
}`, "",{"version":3,"sources":["webpack://./src/app/_components/feedback/queue-pending-overlay/queue-pending-overlay.component.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,cAAA;AACF;;AAEA;EACE,kBAAA;EACA,QAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,qCAAA;EACA,0BAAA;AACF;;AAEA;EACE,kCAAA;AACF;;AAEA;EACE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,UAAA;EACA,mGAAA;EACA,sDAAA;AACF;;AAEA;EACE,mGAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,aAAA;EACA,cAAA;EACA,qBAAA;EACA,0CAAA;EACA,oCAAA;EACA,cAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;;AAEA;EACE,uCAAA;EACA,kCAAA;EACA,cAAA;EACA,0CAAA;AACF;;AAEA;EACE;IACE,4BAAA;EACF;EAEA;IACE,2BAAA;EAAF;AACF","sourcesContent":[":host {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: block;\n}\n\n.queue-overlay {\n  position: absolute;\n  inset: 0;\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.45);\n  backdrop-filter: blur(1px);\n}\n\nbody.dark .queue-overlay {\n  background: rgba(17, 24, 39, 0.35);\n}\n\n.queue-shimmer {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 60%;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.75) 50%, transparent 100%);\n  animation: queue-pending-shimmer 1.25s linear infinite;\n}\n\nbody.dark .queue-shimmer {\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.16) 50%, transparent 100%);\n}\n\n.queue-center {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.queue-icon-wrap {\n  width: 2.2rem;\n  height: 2.2rem;\n  border-radius: 9999px;\n  border: 1px solid rgba(148, 163, 184, 0.6);\n  background: rgba(255, 255, 255, 0.9);\n  color: #334155;\n  box-shadow: 0 10px 20px rgba(15, 23, 42, 0.18);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\nbody.dark .queue-icon-wrap {\n  border-color: rgba(148, 163, 184, 0.45);\n  background: rgba(15, 23, 42, 0.82);\n  color: #e2e8f0;\n  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.4);\n}\n\n@keyframes queue-pending-shimmer {\n  from {\n    transform: translateX(-120%);\n  }\n\n  to {\n    transform: translateX(280%);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
